module.exports = __webpack_public_path__ + "img/Funny404.4de5cbe9.png";